










import { Component, Vue } from 'vue-property-decorator'
import NavBar from '@/components/NavBar.vue'
import FooterSection from '@/components/FooterSection.vue'

import { BContainer } from 'bootstrap-vue'

@Component({
  components: { NavBar, BContainer, FooterSection }
})
export default class App extends Vue {}
